{
    "ChangeUserAgent_Title": "Browser-Anzeigeprofil festlegen",
    "ChangeUserAgent_SubTitle": "Wählen Sie das Browser-Anzeigeprofil aus, in dem Sie Webseiteninhalte während Ihrer aktuellen Websitzung auf diesem Computer anzeigen möchten.",
    "ChangeUserAgent_FieldName_BrowserProfile": "Browserprofil",
    "ChangeUserAgent_Options_ForceAutomaticBrowserDetection": "[Automatische Browsererkennung erzwingen]",
    "ChangeUserAgent_FooterActions_Apply": "Anwenden",
    "ChangeUserAgent_FooterActions_Cancel": "Stornieren",
    "NAME": "ChangeUserAgentLanguage"
}